<template>
  <div class="logistics-certificate">
    <div class="main">
      <!-- 查询表单 -->
      <div class="logistics-certificate-container" v-if="show">
        <h3 class="title">证书查询</h3>
        <div class="form">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item  prop="name">
              <el-input type="password" v-model="ruleForm.name" autocomplete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item  prop="id">
              <el-input type="password" v-model="ruleForm.id" autocomplete="off" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item  prop="phone">
              <el-input v-model.number="ruleForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item  prop="vertical">
              <el-input v-model.number="ruleForm.verifyCode" placeholder="请输入验证码"  style="max-width:243px"></el-input>
              <el-button class="get-code" @click="getCode" v-if="showCode">获取验证码</el-button>
              <el-button class="get-code" v-else>{{`重新发送(${count}s)`}}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 证书展示 -->
      <div class="logistics-certificate-show-container flex-layout" v-else>
        <div v-for="(item,index) in certificateList" :key="index" class="certificate-item csp" @click="openDialog(item)">
          <img src="" alt="" class="certificate-img">
          <h5 class="name wes">{{item.name}}</h5>
          <p class="time">{{item.time}}</p>
        </div>
      </div>
    </div>
    <!-- 证书放大展示弹窗 -->
     <el-dialog
      class="certificate-dialog"
      :title="current.name"
      :visible.sync="dialogVisible"
      width="35%"
      center>
       <img src="" alt="" class="certificate-img">
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
   data() {
     var checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'));
        } else {
          return callback();
        }
      };
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else if (!/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(value)) {
          return callback(new Error('手机号格式错误'));
        } else {
          return callback();
        }
      };
      var checkCode = (rule, value, callback) => {
        console.log(value)
        if(!value) {
          return callback(new Error('验证码不能为空'));
        } else {
          let params = {
              phone:this.verifyForm.phone,
              code:String(value)
            }
            this.$Api.Login.checkCode(params).then((resData)=>{
               console.log(resData)
               if(resData.data.result) {
                  return callback();
               } else {
                this.$message({
                  message: resData.data.msg,
                  type: 'error'
                });
                return callback(new Error('验证码错误'));
               }
            })
        }
      };
      var checkID = (rule, value, callback) => {
        let reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!value) {
          return callback(new Error("请输入身份证号码"));
        } else if (!reg.test(value)) {
          return callback(new Error("请输入正确的身份证号码"));
        } else {
          return callback();
        }
      };
      return {
        show:true,
        showCode:true, //显示倒计时
        timer:"", //倒计时定时器
        count:0, //计数
        current:{}, //当前证书
        dialogVisible:false,//显示证书放大弹窗
        ruleForm: {
          name: '',
          phone: '',
          id:'',
          verifyCode: ''
        },
        rules: {
          name: [
            { validator: checkName, trigger: 'blur' }
          ],
          phone: [
            { validator: checkPhone, trigger: 'blur' }
          ],
          verifyCode: [
            { validator: checkCode, trigger: 'blur' }
          ],
          id:[
            { validator: checkID, trigger: 'blur' }
          ]
        },
        certificateList:[
          {
            img:'',
            name:'普通结业证书',
            time:'2020.07.19'
          },
          {
            img:'',
            name:'普通结业证书',
            time:'2020.07.19'
          },
          {
            img:'',
            name:'普通结业证书',
            time:'2020.07.19'
          },
          {
            img:'',
            name:'普通结业证书',
            time:'2020.07.19'
          },
          {
            img:'',
            name:'普通结业证书',
            time:'2020.07.19'
          },
        ]
      };
    },
    methods: {
      openDialog(item) {
        this.dialogVisible = true;
        this.current = item;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 获取验证码
      async getCode(){
        if(!/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(this.ruleForm.phone)) {
          this.$message({
            message: '手机号格式错误',
            type: 'error'
          });
          return
        }
        this.countDown();
        let params = {
          phone : this.phoneForm.phone
        }
        let resData =  await this.$Api.Login.getVerifyCode(params)
        // console.log(resData);
        if(resData.code === 200 && resData.msg === "请求成功") {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: resData.msg,
            type: 'error'
          });
        }
      },
      // 倒计时
      countDown(){
        const TIME_COUNT = 60;
        if (!this.timer) {
         this.count = TIME_COUNT;
         this.showCode = false;
         this.timer = setInterval(() => {
         if (this.count > 0 && this.count <= TIME_COUNT) {
           this.count--;
          } else {
           this.showCode = true;
           clearInterval(this.timer);
           this.timer = null;
          }
         }, 1000)
        }
      }, 
    }
}
</script>

<style lang="less" scoped>
  .logistics-certificate {
    
    background-color: #F2F2F2;
    .main {
      width: 1200px;
      margin: 0 auto;
      background-color: #fff;
      overflow: hidden;
    }

    .logistics-certificate-container {
      margin: 106px auto 213px;
      width: 642px;

      h3.title {
        line-height: 67px;

        color: #fff;
        font-size: 22px;
        text-align: center;

        background-color: #2E7BD6;
        border-radius: 4px;
      }

      .form {
        width: 433px;
        margin: 46px auto;
      }

      /deep/ .el-input .el-input__inner {
        border-radius: 10px;
        line-height: 47px;
        height: 47px;
      }

      /deep/ .el-form-item {
        margin-bottom: 31px;
      }

      /deep/ .el-button--primary {
        border-radius: 10px;
        width: 100%;
        line-height: 35px;
        background-color: #1C4B90;
        font-size: 20px;
        letter-spacing: 2px;
      }

      .get-code {
        margin-left: 18px;
        border-radius: 10px;
        border: 1px solid #1c4b90;
        width: 172px;
        line-height: 23px;
        font-size: 16px;
        color: #1C4B90;
      }
    }

    .logistics-certificate-show-container {
      padding: 96px 111px 97px;
      flex-wrap:  wrap;

      .certificate-item {
        margin-right: 66px;
        margin-bottom: 50px;
        border: 1px solid rgba(199, 196, 196, 0.25);
        padding: 13px 10px 14px 12px;
        width: 26.3%;

        &:nth-child(3n) {
          margin-right: 0;
        }

        h5.name {
          margin-bottom: 6px;
          font-size: 16px;
        } 
        p.time {
          font-size: 13px;
          color: #888;
        }

        h5.name,
        p.time {
          padding-left: 5px;
        }
      }

      .certificate-img {
        width: 100%;
        height: 193px;
        margin-bottom: 10px;
      }

      

    }

    .certificate-dialog {
      .certificate-img {
        width: 100%;
        height: 450px;
        background-color: tomato;
      }
    }
  }
</style>